import { useState, useEffect } from 'react';
import API from '../../API';

export const useAssetQR = (id) => {
    const [ data, setData ] = useState({ qr: {}, assets: [] });
    const { getQRListener } = API;

    useEffect(() => {
        return () => {
            if (!data.assets) return;
            
            for (const asset of data.assets) {
                if (asset?.url?.startsWith('blob:')) {
                    URL.revokeObjectURL(asset.url)
                };
            };
        };
    },[data?.assets]);

    useEffect(() => {
        let isMounted = true;
        let listener;

        const handleGetQR = async () => {
            try {
                const handleListenerData = async (qr) => {
                    if (qr) {
                        const { asset } = qr;
                        const assets = [];
                        for (const file of asset.files) {
                            const fileType = handleFileType(file.path);
                            const url = fileType === 'pdf' ? await handlePdf(file.url) : file.url;
                            const assetObj = {
                                path: file.path,
                                url,
                                fileType
                            };
    
                            assets.push(assetObj);
                        };
    
                        isMounted && setData({ qr, assets });
                    };
                };

                listener = getQRListener(id, handleListenerData);
            } catch (err) {
                console.error(err);
            };
        };
        
        if (id && !Object.keys(data.qr).length) {
            handleGetQR();
        };
        
        return () => {
            isMounted = false;            
            setData({ qr: {}, assets: [] });
            listener && listener();
        };
    },[id]);
    
    return [data.assets, data.qr];
};

export const handleFileType = (route) => {
    if (route?.includes('.mp4') || route?.includes('.webm') || route?.includes('.mov')) {
        return 'video';
    } else if (route?.includes('.jpeg') || route?.includes('.webp') || route?.includes('.jpg') || route?.includes('.png') || route?.includes('.gif')) {
        return 'image';
    } else if (route?.includes('.pdf')) {
        return 'pdf';
    };
};

export const handlePdf = async (route) => {
    try {
        const res = await fetch(route);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        return url;
    } catch (err) {
        console.error(err);
        return null;
    };
};
